import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function EndToEndAnalytics() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = false;

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Your Trusted Data Visualization Agency for Actionable Insights
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We transform raw data into clear and meaningful visual
                representations. Our data visualization strategies simplify
                complex information and improve decision-making. We optimize
                dashboard structures and refine graphical elements.
                {!state.auth.isMobile
                  ? "This makes sure that every dataset is presented in a way that drives better understanding and faster business actions."
                  : ""}
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Visual Insights"
                  subtitle1="Transform data into actionable visuals."
                  title2="Clarity at a Glance"
                  subtitle2="Simplify complex data for better decisions."
                  title3="Interactive Dashboards"
                  subtitle3="Explore and analyze with ease."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={
              <h2>
                Data Visualization Services for Better Clarity and
                Decision-Making
              </h2>
            }
            subtitle={
              <div>
                At Riches Media Digital we create data visualization models that
                improve analytical efficiency. Our team structures data and
                refines visual elements to present information effectively. We
                make sure that every dataset is accessible and actionable. Our
                tailored approach improves reporting clarity and reinforces
                data-driven strategies.
              </div>
            }
            image={
              <img
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/datavisualization.jpg")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <OurProcess
            process={"Our Data Visualization Process"}
            invert={!dark}
            step1={"Data Structuring and Organization"}
            step1description={
              "We refine raw datasets and optimize information flow. Our team cleans inconsistencies and improves data structuring. We also categorize insights to make analysis seamless."
            }
            step2={"Graphical Representation and Visual Optimization"}
            step2description={
              "We develop interactive charts and refine visual hierarchies. Our team selects the best visualization formats for different data types. We also improve element positioning to maximize readability."
            }
            step3={"Dashboard Design and Customization"}
            step3description={
              "We design intuitive dashboards and improve information accessibility. Our team refines layouts and optimizes widget placements. We also customize interfaces to match specific business needs."
            }
            step4={"Performance Tracking and Analytical Insights"}
            step4description={
              "We track visualization effectiveness and refine data models. Our team measures user engagement and improves reporting formats. We also test layout variations to improve interaction efficiency."
            }
          />
          <Advantages
            invert={!dark}
            title={"Advantages of Our Data Visualization For Businesses"}
            title1={"Clearer Business Insights"}
            subtitle1={
              "Our experts first structure datasets to improve information clarity. A well-organized visual flow strengthens analytical accuracy."
            }
            title2={"Faster Decision-Making"}
            subtitle2={
              "We refine data presentations and improve accessibility. This helps businesses extract insights quickly and act faster."
            }
            title3={"Stronger Reporting Efficiency"}
            subtitle3={
              "Our team develops structured dashboards and optimizes information flow. This improves team collaboration and speeds up analysis."
            }
            title4={"Seamless Data Interpretation"}
            subtitle4={
              "We remove unnecessary complexity and improve visual hierarchies. Well-designed visual models simplify data evaluation."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={
              <h2>
                Convert Raw Data into Visual Intelligence with Precision
                Visualization
              </h2>
            }
            subtitle="At Riches Media Digital, we convert scattered datasets into structured visual insights that drive decision-making. Our data visualization solutions eliminate complexity and improve analytical clarity. We refine information flow and structure visual elements. This ensures that teams access critical insights instantly without manual interpretation. We skillfully track real-time trends or simplify complex reports along with creating interactive visual models that improve accuracy and efficiency."
            image={
              <img
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/datavisualization2.webp")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What Data Visualization Services Will You Get"}
            invert={!dark}
            title1={"Strategic Data Visualization Execution"}
            title2={"Interactive Dashboard Development"}
            title3={"Data Structuring and Cleaning Experts"}
            title4={"Optimized Visual Representation for Clarity"}
            title5={"Real-Time Data Integration Solutions"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            invert={!dark}
            q1="What is data visualization?"
            a1="Data visualization transforms raw data into visual formats such as graphs and charts. It involves structuring datasets and refining graphical elements. It further encircles dashboard customization to improve data interpretation."
            q2="Why is data visualization important for my business?"
            a2="Data visualization improves analytical clarity and strengthens reporting accuracy. Well-designed visuals simplify decision-making and help businesses act faster. It also makes complex data more accessible for teams at all levels."
            q3="How long does it take to implement these solutions?"
            a3="Implementation time depends on data complexity and customization needs. Businesses start seeing improvements within three to six weeks based on integration and testing. Continuous refinement ensures long-term usability."
            q4="What factors affect data visualization effectiveness?"
            a4="Effectiveness depends on data structuring and visualization design. Clear chart selections and optimized layouts further improve analytical accuracy."
            q5="How do you determine the best visualization method?"
            a5="We conduct data analysis and user experience testing to select the right visualization formats. Our team prioritizes chart readability and dashboard accessibility. We also refine graphical elements to improve clarity."
            q6="How do you measure data visualization success?"
            a6="Success is measured through reporting accuracy and user engagement. We track dashboard interactions and analytical efficiency to refine visualization strategies. Regular performance reviews ensure that insights remain actionable."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
